<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2 v-if="$vuetify.breakpoint.lgAndUp">
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >{{ $t("dashboard.gconsentdetail") }}
            </h2>
            <h3 v-else>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >{{ $t("dashboard.gconsentdetail") }}
            </h3>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title class="bg-card"
                >{{ $t("dashboard.cor") }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="mr-12">
                <v-layout row wrap ml-3 pa-1>
                  <v-flex xs11 lg11
                    ><b class="mr-2">{{ $t("dashboard.policy") }} :</b>
                    <a v-on:click="Fn_DetailPolicy">{{ PolicyHeader }} </a>
                    <br />
                    <b>{{ $t("dashboard.org") }} :</b> {{ BusinessNameTh }}
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs11 lg11 pt-5 v-for="(item, index) in Consent" :key="index">
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                {{ index + 1 }}. {{ $t("consentform.head") }}
                <b class="ml-2">{{ item.ConsentHeader }}</b>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap ml-3 pa-1>
                  <v-flex xs11 lg11>
                    <div class="pb-2" v-if="CheckStatus === 'active'">
                      <b> {{ $t("dashboard.status") }} </b>
                      <b v-if="item.Status === 'approve'" class="green--text">
                        {{ $t("dashboard.statusapp") }}</b
                      >
                      <b
                        v-else-if="item.Status === 'unapprove'"
                        class="red--text"
                      >
                        {{ $t("dashboard.statusreject") }}</b
                      >
                      <b
                        v-else-if="item.Status === 'wait'"
                        class="orange--text"
                      >
                        {{ $t("dashboard.statuspen") }}</b
                      >
                    </div>
                    <div v-else-if="CheckStatus === 'petition'">
                      <b> {{ $t("dashboard.status") }} </b>
                      <b class="red--text"> ถอนความยินยอม</b>
                    </div>
                    <div class="pb-1">
                      <b>{{ $t("dashboard.detail") }}</b>
                    </div>
                    <div v-html="item.ConsentDetail"></div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogGeneralConsent
        :show="DialogGeneral"
        :_header="PolicyHeader"
        :_detail="PolicyDetail"
        @closeDialogDelete="DialogGeneral = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import DialogGeneralConsent from "@/components/dialog/DialogGeneralConsentDetail.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogGeneralConsent, OverlaySearch },
  data: function () {
    return {
      Consent: [],
      DataConsent: [],
      PolicyHeader: "",
      PolicyName: "",
      PolicyDetail: "",
      BusinessNameTh: "",
      CheckStatus: "",
      loadingDownloadData: false,
      DialogGeneral: false,
    };
  },
  computed: {
    ...mapGetters(["DataGroupConsentOnechat"]),
    ...mapGetters(["DataGroupConsentOnechatPath"]),
    ...mapGetters(["Business"]),
    _SendId: {
      get() {
        return this.DataGroupConsentOnechat.SendId || "-";
      },
    },
    _PathHistory: {
      get() {
        return this.DataGroupConsentOnechatPath || "-";
      },
    },
  },
  mounted() {
    this.Fn_GetDataPolicy();
  },
  methods: {
    Fn_GetDataPolicy() {
      this.loadingDownloadData = true;
      var payload = {
        UserName: this.$cookies.get("ChatUsername"),
        AccountId: this.$cookies.get("ChatAccountId"),
        SendId: this._SendId,
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/GetConsentId",
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.DataConsent = response.data.Message;
            this.Consent = response.data.Message.Consent;
            this.PolicyName = response.data.Message.Name;
            this.PolicyHeader = response.data.Message.PolicyHeader;
            this.PolicyDetail = response.data.Message.PolicyDetail;
            this.BusinessNameTh = response.data.Message.BusinessNameTh;
            this.CheckStatus = response.data.Message.Status;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_BackIndex() {
      this.$router.push({ path: this._PathHistory });
    },
    Fn_DetailPolicy() {
      this.DialogGeneral = true;
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.bg-card {
  background-color: #eeeeee;
}
</style>
